<template>
  <div class="service-layout-container">
    <router-link
      to="/"
      class="header-logo-link col-auto"
      :class="{
        'small-img':
          $route.path === '/service/reset-password' ||
          $route.path === '/service/confirm-email',
      }"
    >
      <img
        class="header-logo"
        src="../assets/logo.png"
        alt="4castersports Logo"
      />
    </router-link>
    <div class="service-layout-wrapper">
      <router-view />
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="scss">
@use 'sass:map';
@use '@/scss/theme/variables.scss' as theme;

.service-layout-container {
  min-height: 100vh;
  background: theme.$color-primary;
  width: 100%;
  padding: 0 16px;

  header {
    padding: 40px 0;

    @media screen and (max-width: map.get(theme.$grid-breakpoints, md)) {
      padding: 20px 0;
    }

    .header-logo {
      height: 85px;
      width: auto;
    }
  }
}

.service-layout-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.small-img {
  padding-top: 25px;
  padding-bottom: 50px;
  display: flex;
  justify-content: center;

  & img {
    width: 63px;
    height: 77px;
  }
}
</style>
